import { useEffect, useState } from 'react';
import getColumnClass from '../../utils/getColumnClass';
import CardSkeleton from '../Common/CardSkeleton';
import GridControls from '../Common/GridControls';
import ProductCard from '../Shop/ProductCard';

function FeaturedProducts({ error, featuredProducts, isLoading }) {
  const [gridSize, setGridSize] = useState(() => {
    const storeGridZize = localStorage.getItem('gridSize');
    return storeGridZize ? parseInt(storeGridZize, 10) : 4;
  });
  useEffect(() => {
    localStorage.setItem('gridSize', gridSize.toString());
  }, [gridSize]);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <div className="container-fluid px-4">
      {/* Header */}
      <div className="row justify-content-center">
        <div className="col-12 text-center">
          <div className="categories_title">
            <h2 className="fw-bold">Featured Products</h2>
            <hr className="featured_underline mb-3" />
          </div>
          <p className="featured_product_text">
            Find the best products, carefully chosen for quality, style, and
            great value.
          </p>
        </div>
      </div>

      {/* Grid Controls */}
      <GridControls
        gridSize={gridSize}
        setGridSize={setGridSize}
        windowWidth={windowWidth}
      />

      {/* Product Cards */}
      <div className="row">
        {error && <em className="form_error">{error}</em>}
        {isLoading && (
          <CardSkeleton
            gridSize={gridSize}
            windowWidth={windowWidth}
            cards={8}
          />
        )}
        {!isLoading &&
          !error &&
          featuredProducts.map((product) => (
            <div
              key={product.product_id}
              className={`${getColumnClass(gridSize, windowWidth)} p-2`}
            >
              <ProductCard product={product} />
            </div>
          ))}
      </div>
    </div>
  );
}

export default FeaturedProducts;
